import { ROUTE_NAMES } from './routeNames.const'

export const routeAdvisorBudget = {
  path: '/advisor-budget',
  name: ROUTE_NAMES.advisorBudget,
  component: () =>
    import(
      /* webpackChunkName: "AdvisorBudget" */ 'src/pages/AdvisorBudget/AdvisorBudget.vue'
    ),
}
